export const dataRaw = {
  "ASD-GSE-01CR01-PAC002": [
    {
      Year: "2015",
      "SUM of Approximate Cost": "6759",
      "SUM of Expected Fault Count": "10",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "10459",
      "Capital Cost": "100000",
      "Total Cost": "110459",
      "Total Cost of Ownership": "110459",
      "Annualized Cost": "110459.1425",
      "Total Cost - Partial Refurbishment": "158367.314",
      "Total Cost - Replacement": "206275.4855",
    },
    {
      Year: "2016",
      "SUM of Approximate Cost": "7853",
      "SUM of Expected Fault Count": "13",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "11553",
      "Capital Cost": "",
      "Total Cost": "11553",
      "Total Cost of Ownership": "122012",
      "Annualized Cost": "61005.94982",
      "Total Cost - Partial Refurbishment": "9242.205721",
      "Total Cost - Replacement": "6931.654291",
    },
    {
      Year: "2017",
      "SUM of Approximate Cost": "8117",
      "SUM of Expected Fault Count": "14",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "11817",
      "Capital Cost": "",
      "Total Cost": "11817",
      "Total Cost of Ownership": "133829",
      "Annualized Cost": "44609.55226",
      "Total Cost - Partial Refurbishment": "9453.405721",
      "Total Cost - Replacement": "7090.054291",
    },
    {
      Year: "2018",
      "SUM of Approximate Cost": "6759",
      "SUM of Expected Fault Count": "10",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "10459",
      "Capital Cost": "",
      "Total Cost": "10459",
      "Total Cost of Ownership": "144288",
      "Annualized Cost": "36071.94982",
      "Total Cost - Partial Refurbishment": "8367.313988",
      "Total Cost - Replacement": "6275.485491",
    },
    {
      Year: "2019",
      "SUM of Approximate Cost": "8117",
      "SUM of Expected Fault Count": "14",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "11817",
      "Capital Cost": "",
      "Total Cost": "11817",
      "Total Cost of Ownership": "156105",
      "Annualized Cost": "31220.91128",
      "Total Cost - Partial Refurbishment": "9453.405721",
      "Total Cost - Replacement": "7090.054291",
    },
    {
      Year: "2020",
      "SUM of Approximate Cost": "7853",
      "SUM of Expected Fault Count": "13",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "11553",
      "Capital Cost": "",
      "Total Cost": "11553",
      "Total Cost of Ownership": "167657",
      "Annualized Cost": "27942.8856",
      "Total Cost - Partial Refurbishment": "9242.205721",
      "Total Cost - Replacement": "6931.654291",
    },
    {
      Year: "2021",
      "SUM of Approximate Cost": "7971",
      "SUM of Expected Fault Count": "13",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "11671",
      "Capital Cost": "",
      "Total Cost": "11671",
      "Total Cost of Ownership": "179328",
      "Annualized Cost": "25618.31953",
      "Total Cost - Partial Refurbishment": "9336.738521",
      "Total Cost - Replacement": "7002.553891",
    },
    {
      Year: "2022",
      "SUM of Approximate Cost": "6905",
      "SUM of Expected Fault Count": "11",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "10605",
      "Capital Cost": "",
      "Total Cost": "10605",
      "Total Cost of Ownership": "189933",
      "Annualized Cost": "23741.65165",
      "Total Cost - Partial Refurbishment": "8483.981188",
      "Total Cost - Replacement": "6362.985891",
    },
    {
      Year: "2023",
      "SUM of Approximate Cost": "8117",
      "SUM of Expected Fault Count": "14",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "11817",
      "Capital Cost": "",
      "Total Cost": "11817",
      "Total Cost of Ownership": "201750",
      "Annualized Cost": "22416.66337",
      "Total Cost - Partial Refurbishment": "9453.405721",
      "Total Cost - Replacement": "7090.054291",
    },
    {
      Year: "2024",
      "SUM of Approximate Cost": "7707",
      "SUM of Expected Fault Count": "12",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "11407",
      "Capital Cost": "",
      "Total Cost": "11407",
      "Total Cost of Ownership": "213157",
      "Annualized Cost": "21315.68935",
      "Total Cost - Partial Refurbishment": "9125.538521",
      "Total Cost - Replacement": "6844.153891",
    },
    {
      Year: "2025",
      "SUM of Approximate Cost": "8499",
      "SUM of Expected Fault Count": "16",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "12199",
      "Capital Cost": "",
      "Total Cost": "12199",
      "Total Cost of Ownership": "225356",
      "Annualized Cost": "20486.9296",
      "Total Cost - Partial Refurbishment": "9759.465648",
      "Total Cost - Replacement": "7319.599236",
    },
    {
      Year: "2026",
      "SUM of Approximate Cost": "10911",
      "SUM of Expected Fault Count": "17",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "14611",
      "Capital Cost": "",
      "Total Cost": "14611",
      "Total Cost of Ownership": "239967",
      "Annualized Cost": "19997.22897",
      "Total Cost - Partial Refurbishment": "11688.41765",
      "Total Cost - Replacement": "8766.313236",
    },
    {
      Year: "2027",
      "SUM of Approximate Cost": "11672",
      "SUM of Expected Fault Count": "19",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "15372",
      "Capital Cost": "",
      "Total Cost": "15372",
      "Total Cost of Ownership": "255339",
      "Annualized Cost": "19641.46526",
      "Total Cost - Partial Refurbishment": "12297.84058",
      "Total Cost - Replacement": "9223.380436",
    },
    {
      Year: "2028",
      "SUM of Approximate Cost": "14876",
      "SUM of Expected Fault Count": "24",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "18576",
      "Capital Cost": "",
      "Total Cost": "18576",
      "Total Cost of Ownership": "273915",
      "Annualized Cost": "19565.35343",
      "Total Cost - Partial Refurbishment": "14860.71971",
      "Total Cost - Replacement": "11145.53978",
    },
    {
      Year: "2029",
      "SUM of Approximate Cost": "19027",
      "SUM of Expected Fault Count": "31",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "22727",
      "Capital Cost": "",
      "Total Cost": "22727",
      "Total Cost of Ownership": "296642",
      "Annualized Cost": "19776.14848",
      "Total Cost - Partial Refurbishment": "18181.82337",
      "Total Cost - Replacement": "13636.36753",
    },
  ],
  "ASD-GSE-03CR02-PAC003": [
    {
      Year: "2015",
      "SUM of Approximate Cost": "16054",
      "SUM of Expected Fault Count": "5",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "19754",
      "Capital Cost": "100000",
      "Total Cost": "119754",
      "Total Cost of Ownership": "119754",
      "Annualized Cost": "119753.7058",
      "Total Cost - Partial Refurbishment": "165802.9646",
      "Total Cost - Replacement": "211852.2235",
    },
    {
      Year: "2016",
      "SUM of Approximate Cost": "16989",
      "SUM of Expected Fault Count": "7",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "20689",
      "Capital Cost": "",
      "Total Cost": "20689",
      "Total Cost of Ownership": "140443",
      "Annualized Cost": "70221.56709",
      "Total Cost - Partial Refurbishment": "16551.54274",
      "Total Cost - Replacement": "12413.65705",
    },
    {
      Year: "2017",
      "SUM of Approximate Cost": "26605",
      "SUM of Expected Fault Count": "9",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "30305",
      "Capital Cost": "",
      "Total Cost": "30305",
      "Total Cost of Ownership": "170748",
      "Annualized Cost": "56915.91781",
      "Total Cost - Partial Refurbishment": "24243.69541",
      "Total Cost - Replacement": "18182.77155",
    },
    {
      Year: "2018",
      "SUM of Approximate Cost": "16989",
      "SUM of Expected Fault Count": "7",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "20689",
      "Capital Cost": "",
      "Total Cost": "20689",
      "Total Cost of Ownership": "191437",
      "Annualized Cost": "47859.29547",
      "Total Cost - Partial Refurbishment": "16551.54274",
      "Total Cost - Replacement": "12413.65705",
    },
    {
      Year: "2019",
      "SUM of Approximate Cost": "26895",
      "SUM of Expected Fault Count": "9",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "30595",
      "Capital Cost": "",
      "Total Cost": "30595",
      "Total Cost of Ownership": "222032",
      "Annualized Cost": "44406.43836",
      "Total Cost - Partial Refurbishment": "24476.00794",
      "Total Cost - Replacement": "18357.00595",
    },
    {
      Year: "2020",
      "SUM of Approximate Cost": "31022",
      "SUM of Expected Fault Count": "7",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "34722",
      "Capital Cost": "",
      "Total Cost": "34722",
      "Total Cost of Ownership": "256755",
      "Annualized Cost": "42792.42483",
      "Total Cost - Partial Refurbishment": "27777.88577",
      "Total Cost - Replacement": "20833.41433",
    },
    {
      Year: "2021",
      "SUM of Approximate Cost": "27467",
      "SUM of Expected Fault Count": "11",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "31167",
      "Capital Cost": "",
      "Total Cost": "31167",
      "Total Cost of Ownership": "287922",
      "Annualized Cost": "41131.71382",
      "Total Cost - Partial Refurbishment": "24933.95819",
      "Total Cost - Replacement": "18700.46865",
    },
    {
      Year: "2022",
      "SUM of Approximate Cost": "16989",
      "SUM of Expected Fault Count": "7",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "20689",
      "Capital Cost": "",
      "Total Cost": "20689",
      "Total Cost of Ownership": "308611",
      "Annualized Cost": "38576.42815",
      "Total Cost - Partial Refurbishment": "16551.54274",
      "Total Cost - Replacement": "12413.65705",
    },
    {
      Year: "2023",
      "SUM of Approximate Cost": "26282",
      "SUM of Expected Fault Count": "8",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "29982",
      "Capital Cost": "",
      "Total Cost": "29982",
      "Total Cost of Ownership": "338593",
      "Annualized Cost": "37621.48649",
      "Total Cost - Partial Refurbishment": "23985.56261",
      "Total Cost - Replacement": "17989.17195",
    },
    {
      Year: "2024",
      "SUM of Approximate Cost": "16989",
      "SUM of Expected Fault Count": "7",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "20689",
      "Capital Cost": "",
      "Total Cost": "20689",
      "Total Cost of Ownership": "359283",
      "Annualized Cost": "35928.28068",
      "Total Cost - Partial Refurbishment": "16551.54274",
      "Total Cost - Replacement": "12413.65705",
    },
    {
      Year: "2025",
      "SUM of Approximate Cost": "41864",
      "SUM of Expected Fault Count": "11",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "45564",
      "Capital Cost": "",
      "Total Cost": "45564",
      "Total Cost of Ownership": "404846",
      "Annualized Cost": "36804.22438",
      "Total Cost - Partial Refurbishment": "36450.9291",
      "Total Cost - Replacement": "27338.19683",
    },
    {
      Year: "2026",
      "SUM of Approximate Cost": "17534",
      "SUM of Expected Fault Count": "9",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "21234",
      "Capital Cost": "",
      "Total Cost": "21234",
      "Total Cost of Ownership": "426081",
      "Annualized Cost": "35506.73237",
      "Total Cost - Partial Refurbishment": "16987.45619",
      "Total Cost - Replacement": "12740.59215",
    },
    {
      Year: "2027",
      "SUM of Approximate Cost": "42976",
      "SUM of Expected Fault Count": "14",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "46676",
      "Capital Cost": "",
      "Total Cost": "46676",
      "Total Cost of Ownership": "472757",
      "Annualized Cost": "36365.92693",
      "Total Cost - Partial Refurbishment": "37341.00935",
      "Total Cost - Replacement": "28005.75701",
    },
    {
      Year: "2028",
      "SUM of Approximate Cost": "58240",
      "SUM of Expected Fault Count": "17",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "61940",
      "Capital Cost": "",
      "Total Cost": "61940",
      "Total Cost of Ownership": "534697",
      "Annualized Cost": "38192.64881",
      "Total Cost - Partial Refurbishment": "49552.02651",
      "Total Cost - Replacement": "37164.01988",
    },
    {
      Year: "2029",
      "SUM of Approximate Cost": "44429",
      "SUM of Expected Fault Count": "18",
      "Planned Maintenance Cost": "3700",
      "Total Maintenance Cost": "48129",
      "Capital Cost": "",
      "Total Cost": "48129",
      "Total Cost of Ownership": "582826",
      "Annualized Cost": "38855.09423",
      "Total Cost - Partial Refurbishment": "38503.46413",
      "Total Cost - Replacement": "28877.5981",
    },
  ],
  "LSD-MWB-01WK13-PAC004": [
    {
      Year: "2015",
      "SUM of Approximate Cost": "0",
      "SUM of Expected Fault Count": "0",
      "Planned Maintenance Cost": "1760",
      "Total Maintenance Cost": "1760",
      "Capital Cost": "60,000.00",
      "Total Cost": "61760",
      "Total Cost of Ownership": "61760",
      "Annualized Cost": "61760",
      "Total Cost - Partial Refurbishment": "91408",
      "Total Cost - Replacement": "121056",
    },
    {
      Year: "2016",
      "SUM of Approximate Cost": "2942",
      "SUM of Expected Fault Count": "1",
      "Planned Maintenance Cost": "1760",
      "Total Maintenance Cost": "4702",
      "Capital Cost": "",
      "Total Cost": "4702",
      "Total Cost of Ownership": "66462",
      "Annualized Cost": "33230.97333",
      "Total Cost - Partial Refurbishment": "3761.557333",
      "Total Cost - Replacement": "2821.168",
    },
    {
      Year: "2017",
      "SUM of Approximate Cost": "2942",
      "SUM of Expected Fault Count": "1",
      "Planned Maintenance Cost": "1760",
      "Total Maintenance Cost": "4702",
      "Capital Cost": "",
      "Total Cost": "4702",
      "Total Cost of Ownership": "71164",
      "Annualized Cost": "23721.29778",
      "Total Cost - Partial Refurbishment": "3761.557333",
      "Total Cost - Replacement": "2821.168",
    },
    {
      Year: "2018",
      "SUM of Approximate Cost": "961",
      "SUM of Expected Fault Count": "1",
      "Planned Maintenance Cost": "1760",
      "Total Maintenance Cost": "2721",
      "Capital Cost": "",
      "Total Cost": "2721",
      "Total Cost of Ownership": "73884",
      "Annualized Cost": "18471.1125",
      "Total Cost - Partial Refurbishment": "2176.445333",
      "Total Cost - Replacement": "1632.334",
    },
    {
      Year: "2019",
      "SUM of Approximate Cost": "2942",
      "SUM of Expected Fault Count": "1",
      "Planned Maintenance Cost": "1760",
      "Total Maintenance Cost": "4702",
      "Capital Cost": "",
      "Total Cost": "4702",
      "Total Cost of Ownership": "78586",
      "Annualized Cost": "15717.27933",
      "Total Cost - Partial Refurbishment": "3761.557333",
      "Total Cost - Replacement": "2821.168",
    },
    {
      Year: "2020",
      "SUM of Approximate Cost": "2942",
      "SUM of Expected Fault Count": "1",
      "Planned Maintenance Cost": "1760",
      "Total Maintenance Cost": "4702",
      "Capital Cost": "",
      "Total Cost": "4702",
      "Total Cost of Ownership": "83288",
      "Annualized Cost": "13881.39056",
      "Total Cost - Partial Refurbishment": "3761.557333",
      "Total Cost - Replacement": "2821.168",
    },
    {
      Year: "2021",
      "SUM of Approximate Cost": "2942",
      "SUM of Expected Fault Count": "1",
      "Planned Maintenance Cost": "1760",
      "Total Maintenance Cost": "4702",
      "Capital Cost": "",
      "Total Cost": "4702",
      "Total Cost of Ownership": "87990",
      "Annualized Cost": "12570.04143",
      "Total Cost - Partial Refurbishment": "3761.557333",
      "Total Cost - Replacement": "2821.168",
    },
    {
      Year: "2022",
      "SUM of Approximate Cost": "961",
      "SUM of Expected Fault Count": "1",
      "Planned Maintenance Cost": "1760",
      "Total Maintenance Cost": "2721",
      "Capital Cost": "",
      "Total Cost": "2721",
      "Total Cost of Ownership": "90711",
      "Annualized Cost": "11338.85583",
      "Total Cost - Partial Refurbishment": "2176.445333",
      "Total Cost - Replacement": "1632.334",
    },
    {
      Year: "2023",
      "SUM of Approximate Cost": "2942",
      "SUM of Expected Fault Count": "1",
      "Planned Maintenance Cost": "1760",
      "Total Maintenance Cost": "4702",
      "Capital Cost": "",
      "Total Cost": "4702",
      "Total Cost of Ownership": "95413",
      "Annualized Cost": "10601.42148",
      "Total Cost - Partial Refurbishment": "3761.557333",
      "Total Cost - Replacement": "2821.168",
    },
    {
      Year: "2024",
      "SUM of Approximate Cost": "2942",
      "SUM of Expected Fault Count": "1",
      "Planned Maintenance Cost": "1760",
      "Total Maintenance Cost": "4702",
      "Capital Cost": "",
      "Total Cost": "4702",
      "Total Cost of Ownership": "100115",
      "Annualized Cost": "10011.474",
      "Total Cost - Partial Refurbishment": "3761.557333",
      "Total Cost - Replacement": "2821.168",
    },
    {
      Year: "2025",
      "SUM of Approximate Cost": "0",
      "SUM of Expected Fault Count": "0",
      "Planned Maintenance Cost": "1760",
      "Total Maintenance Cost": "1760",
      "Capital Cost": "",
      "Total Cost": "1760",
      "Total Cost of Ownership": "101875",
      "Annualized Cost": "9261.34",
      "Total Cost - Partial Refurbishment": "1408",
      "Total Cost - Replacement": "1056",
    },
    {
      Year: "2026",
      "SUM of Approximate Cost": "3903",
      "SUM of Expected Fault Count": "2",
      "Planned Maintenance Cost": "1760",
      "Total Maintenance Cost": "5663",
      "Capital Cost": "",
      "Total Cost": "5663",
      "Total Cost of Ownership": "107537",
      "Annualized Cost": "8961.436944",
      "Total Cost - Partial Refurbishment": "4530.002667",
      "Total Cost - Replacement": "3397.502",
    },
    {
      Year: "2027",
      "SUM of Approximate Cost": "5884",
      "SUM of Expected Fault Count": "2",
      "Planned Maintenance Cost": "1760",
      "Total Maintenance Cost": "7644",
      "Capital Cost": "",
      "Total Cost": "7644",
      "Total Cost of Ownership": "115181",
      "Annualized Cost": "8860.087436",
      "Total Cost - Partial Refurbishment": "6115.114667",
      "Total Cost - Replacement": "4586.336",
    },
    {
      Year: "2028",
      "SUM of Approximate Cost": "3903",
      "SUM of Expected Fault Count": "2",
      "Planned Maintenance Cost": "1760",
      "Total Maintenance Cost": "5663",
      "Capital Cost": "",
      "Total Cost": "5663",
      "Total Cost of Ownership": "120844",
      "Annualized Cost": "8631.688571",
      "Total Cost - Partial Refurbishment": "4530.002667",
      "Total Cost - Replacement": "3397.502",
    },
    {
      Year: "2029",
      "SUM of Approximate Cost": "5884",
      "SUM of Expected Fault Count": "2",
      "Planned Maintenance Cost": "1760",
      "Total Maintenance Cost": "7644",
      "Capital Cost": "",
      "Total Cost": "7644",
      "Total Cost of Ownership": "128488",
      "Annualized Cost": "8565.835556",
      "Total Cost - Partial Refurbishment": "6115.114667",
      "Total Cost - Replacement": "4586.336",
    },
  ],
};
